import { useEffect } from "react";
import {
    MANAGED_SERVICE_CONTEXT_STORAGE_KEY,
    reloadForManagedServiceContextChange,
} from "../services/managedServiceUrlState";

/** Reload other browser tabs after the global Managed-Service tenant changes. */
export const useManagedServiceContextSync = (): void => {
    useEffect(() => {
        const reloadForContextChange = (event: StorageEvent): void => {
            if (event.key === MANAGED_SERVICE_CONTEXT_STORAGE_KEY && event.newValue !== null) {
                reloadForManagedServiceContextChange();
            }
        };

        window.addEventListener("storage", reloadForContextChange);
        return () => window.removeEventListener("storage", reloadForContextChange);
    }, []);
};
